export const DISPLAY_STATUS = {
  UNSIGNED: 'UNSIGNED',
  SIGNED: 'SIGNED',
  LINK_EXPIRED: 'LINK_EXPIRED',
  UNSENT: 'UNSENT'
}

export const PAGE_STATE = {
  INVALID: 'INVALID',
  LOADING: 'LOADING',
  LINK_EXPIRED: 'LINK_EXPIRED',
  SIGNED: 'SIGNED',
  UNSIGNED: 'UNSIGNED'
}

export const API_ERROR = {
  ALREADY_SIGNED: 'This agreement has already been signed.',
  LINK_EXPIRED: 'This signing link has expired.',
  NOT_AVAILABLE: 'This agreement is no longer available to sign.',
  NOT_FOUND: 'Terms and condition assignment not found.',
  MUST_ACCEPT: 'Agreement must be accepted to sign.',
  NAME_REQUIRED: 'Signer name is required.'
}

export const INVALID_LINK_MESSAGE = 'This link is invalid or no longer available.'
export const EXPIRED_LINK_MESSAGE = 'This signing link has expired.'
export const UNABLE_TO_SIGN_MESSAGE = 'Unable to sign the agreement.'
export const UNABLE_TO_REFRESH_MESSAGE = 'Unable to refresh the agreement status. Please reload the page.'
